import { Component } from '@angular/core';

@Component({
  selector: 'app-onboarding-card-placeholder',
  templateUrl: './onboarding-card-placeholder.component.html',
  styleUrls: ['./onboarding-card-placeholder.component.scss'],
})
export class OnboardingCardPlaceholderComponent {}
